import { Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Actionsheet, Popover, useDisclose } from 'native-base';
import React, { useState } from 'react';

import { BasketOfferFilesProps } from '../../../../utils/types';

import { FilesContent } from './FilesContent';
import { TriggerButtonFiles } from './TriggerButtonFiles';

interface ITermsAndDocumentsButton {
  basketOfferFile: BasketOfferFilesProps[] | undefined;
}
export const TermsAndDocumentsButton: React.FC<ITermsAndDocumentsButton> = ({
  basketOfferFile,
}) => {
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  const { isOpen, onOpen, onClose } = useDisclose();
  const [isOpenPopover, setIsOpenPopover] = useState(false);
  const handleActivePopover = () => setIsOpenPopover(true);

  const handleOpenLink = (fileUrl: string) => {
    window.open(fileUrl, '_blank');
  };

  if (isDesktop) {
    return (
      <Popover
        useRNModal
        trigger={(triggerProps) => (
          <TriggerButtonFiles triggerProps={triggerProps} onOpen={handleActivePopover} />
        )}
        isOpen={isOpenPopover}
        onClose={() => setIsOpenPopover((state) => !state)}>
        <Popover.Content minWidth={420} shadow={4} p={Spacing['stack.xxxs']} bg="neutral.white">
          <FilesContent
            handleClose={() => setIsOpenPopover((state) => !state)}
            basketOfferFile={basketOfferFile}
            handleOpenLink={handleOpenLink}
          />
        </Popover.Content>
      </Popover>
    );
  }

  return (
    <>
      <TriggerButtonFiles onOpen={onOpen} />

      <Actionsheet useRNModal isOpen={isOpen} onClose={onClose} size="full">
        <Actionsheet.Content _dragIndicator={{ bg: 'neutral.lightest' }} w={'full'}>
          <FilesContent
            handleClose={onClose}
            basketOfferFile={basketOfferFile}
            handleOpenLink={handleOpenLink}
          />
        </Actionsheet.Content>
      </Actionsheet>
    </>
  );
};
